import React, { useEffect, useRef, useState } from "react";
import { RCCAlert, RCCHookToast, RCCServicesApi } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { useLocation, useParams } from "react-router-dom";
import getUrlSearchParams from "src/utils/getUrlSearchParams";
import Loader from "src/components/Loader";
import { standardErrorMessages } from "src/utils/errors";
import { IConfigsPerformance } from "./interface";
import Performance from "./performance";

const PerformancePage: React.FC = () => {
	const params = useParams<{
        budgetPlanId: string;
    }>();
	
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	
	const query = useLocation();
	const objQueryParams = getUrlSearchParams(query.search);

	const [financialPlanTitle] = useState(objQueryParams?.name || "");
	
	const configs = useRef<IConfigsPerformance>({ 
		divider: "1",
		startDate: new Date(),
		coinPlanned: null,
		coinPlannedInitials: null,
		coinRealized: null,
		coinRealizedInitials: null
	});
	const subsidiaryDefaultValue = useRef<string | undefined>(objQueryParams?.subsidiary ?? undefined);
	const [errorLoading, setErrorLoading] = useState(false);
	const [loading, setLoading] = useState(true);

	const loadData = async () => {
		if(!params.budgetPlanId)
			return;
			
		try{
			setLoading(true);
			setErrorLoading(false);

			const {data} = await RCCServicesApi.getRequest({
				method: "FinancialManagement/PerformanceStartDate",
				urlParameters: {
					budgetPlanId: params.budgetPlanId
				}
			});
			configs.current = {
				...configs.current,
				startDate: data
			};
			setLoading(false);
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar os dados"), addToast);
			setLoading(false);
			setErrorLoading(true);
		}
	};

	useEffect(() => {
		loadData();
	}, []);

	if(!params.budgetPlanId)
		return <RCCAlert 
			title={translate("Atenção")}
			description={translate("Nenhum plano orçamentário selecionado")}
		/>;

	if(loading)
		return <Loader />;


	if(errorLoading)
		return <RCCAlert 
			title={translate("Atenção")}
			description={translate("Não foram encontrados dados")}
		/>;

	return (
		<Performance 
			budgetPlanId={params.budgetPlanId}
			budgetPlanTitle={financialPlanTitle}
			configs={configs.current}
			subsidiaryDefaultValue={subsidiaryDefaultValue.current}
		/>
	);
};

export default PerformancePage;
